module.exports = __webpack_public_path__ + "img/commingsoon.6dc502ba.jpg";